// extracted by mini-css-extract-plugin
export default {"trigger":"_-2Mx-","skeleton-progress":"kVgap"};